export class ModalModel {
  title: string = "";
  content: string = "";
  closeText: string = "";
  openButtonText: string = "";
}
